<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" v-show="tabShow" slot="left">
        <div class="grid-content bg-purple">
          <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
        </div>
      </div>
      <div class="right-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="grid-content bg-purple">
          <div class="boxNew bgbox">
            <div class="time_box dn-content-bg">
              <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="bindgetSearchElem">
              </time-search>
            </div>
            <div class="contant_box dn-content-bg">
              <div class="top">
                <el-row>
                  <el-col :span="16">
                    <div class="toptitle dn-title-bg">整体使用情况</div>
                    <div class="contentOne" style="height:250px;border: 1px solid #dedcdc;">
                      <div style="display: flex;margin-left: 50px">
                        <div style="color:#5da4e4;line-height: 40px;font-size:25px;font-weight:bold">总金额</div>
                        <div style="color:#5da4e4;line-height: 50px;font-weight:bold">(元)</div>
                        <div style="color:#5da4e4;line-height: 40px;font-size:30px">=</div>
                        <div style="color:#5da4e4;font-size:30px">{{totalData}}</div>
                      </div>
                      <div class="topleftcontent">
                        <div class="littlecontent" v-if="ydl">
                          <div class="toplittle">
                            <div style="color:#fff">
                              用电量
                              <span>({{eleUnit}})</span>
                            </div>
                            <div style="color:#fff">{{ydlvalue}}</div>
                          </div>
                          <div class="bottomlittle">
                            <div>
                              费用
                              <span>(元)</span>
                            </div>
                            <div>{{ydlcost}}</div>
                          </div>
                        </div>
                        <div class="littlecontent" v-if="ysl">
                          <div class="toplittle">
                            <div style="color:#fff">
                              用水量
                              <span>({{waterUnit}})</span>
                            </div>
                            <div style="color:#fff">{{yslvalue}}</div>
                          </div>
                          <div class="bottomlittle">
                            <div>
                              费用
                              <span>(元)</span>
                            </div>
                            <div>{{yslcost}}</div>
                          </div>
                        </div>
                        <div class="littlecontent" v-if="yzql">
                          <div class="toplittle">
                            <div style="color:#fff">
                              用蒸汽量
                              <span>({{steamUnit}})</span>
                            </div>
                            <div style="color:#fff">{{yzqlvalue}}</div>
                          </div>
                          <div class="bottomlittle">
                            <div>
                              费用
                              <span>(元)</span>
                            </div>
                            <div>{{yzqlcost}}</div>
                          </div>
                        </div>
                        <div class="littlecontent" v-if="ytrql">
                          <div class="toplittle">
                            <div style="color:#fff">
                              用天然气量
                              <span>({{gasUnit}})</span>
                            </div>
                            <div style="color:#fff">{{ytrqlvalue}}</div>
                          </div>
                          <div class="bottomlittle">
                            <div>
                              费用
                              <span>(元)</span>
                            </div>
                            <div>{{ytrqlcost}}</div>
                          </div>
                        </div>
                        <div class="littlecontent" v-if="diesel">
                          <div class="toplittle">
                            <div style="color:#fff">
                              用柴油量
                              <span>({{dieselUnit}})</span>
                            </div>
                            <div style="color:#fff">{{dieselValue}}</div>
                          </div>
                          <div class="bottomlittle">
                            <div>
                              费用
                              <span>(元)</span>
                            </div>
                            <div>{{dieselCost}}</div>
                          </div>
                        </div>
                        <div class="littlecontent" v-if="gasol">
                          <div class="toplittle">
                            <div style="color:#fff">
                              用液化气体量
                              <span>(gasolUnit)</span>
                            </div>
                            <div style="color:#fff">{{gasolValue}}</div>
                          </div>
                          <div class="bottomlittle">
                            <div>
                              费用
                              <span>(元)</span>
                            </div>
                            <div>{{gasolCost}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="8" style="padding-left: 12.5px;">
                    <div class="toptitle dn-title-bg">费用占比</div>
                    <div class="new-con" id="myChartPie" style="height:250px;border: 1px solid #dedcdc" v-resize="resize"></div>
                  </el-col>
                </el-row>
              </div>
              <div class="center" style="border: 1px solid #dedcdc;">
                <div class="title dn-title-bg" style="display:flex;justify-content:space-between;padding:0 0">
                  <div style="margin: 4px 0 0 9px;">费用支出整体趋势</div>
                  <div>
                    <button v-for="(item,index) in costData" :key="index" v-show="item.show" @click="radioChange(item.name,index)" :class="activecode==index?'btn btnactive dn-title-bg':'btn dn-title-bg'">{{item.name}}</button>
                  </div>
                </div>
                <div class="content">
                  <div id="lineCharts" v-resize="resize"></div>
                </div>
              </div>
              <div class="bottom" v-if="tableshow">
                <div class="title dn-title-bg">具体情况</div>
                <div class="contentOne margintop table-warp">
                  <el-table :data="bottomTableData" border style="width: 100%">
                    <el-table-column :show-overflow-tooltip="true" prop="measureName" label="名称" width="180" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="date" label="时间" width="180" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="ydl" prop="electricenergyUsed" label="电用量(kWh)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="ysl" prop="waterenergyUsed" label="水用量(吨)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="ytrql" prop="gasenergyUsed" label="天然气用量(m³)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="yzql" prop="steamenergyUsed" label="蒸汽用量(吨)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="diesel" prop="dieselenergyUsed" label="柴油用量(t)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="ydl" prop="electricvalue" label="用电总金额(元)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="ysl" prop="watervalue" label="用水总金额(元)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="ytrql" prop="gasvalue" label="用天然气总金额(元)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="yzql" width='200' prop="steamvalue" label="用蒸汽总金额(元)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="diesel" prop="dieselvalue" label="用柴油总金额(元)" align="center"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-if="gasol" prop="gasolvalue" label="用液化石油气总金额(元)" align="center"></el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import { findDataByParam } from '@/utils/index.js'
import NkTable from '@/components/common/NkTable'
import TabTree from '@/components/common/TabTree.vue'
import TimeSearch from '@/components/common/TimeSearch.vue'
import * as utils from '@/utils/index.js'
import handleData from '@/utils/handleData.js'
import dateTool from '@/utils/dateTool'
import BtnShow from '@/components/common/BtnShow.vue'
import ResizeContainer from '@/components/common/resizeContainer.vue'
let allTimeData = [
  {
    type: 'day',
    label: '日',
  },
  {
    type: 'month',
    label: '月',
  },
  {
    type: 'year',
    label: '年',
  },
  {
    type: 'years',
    label: '年度',
  },
]
export default {
  components: { TabTree, NkTable, TimeSearch, BtnShow, ResizeContainer },
  data () {
    return {
      tabShow: true,
      activecode: 0,
      selectNodes: null,
      viewTreeData: [],
      tabPosition: '总费用',
      timeData: allTimeData,
      type: [],
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      bottomTableData: [],
      AllData: null,
      ydl: false,
      ysl: false,
      yzql: false,
      ytrql: false,
      diesel: false,
      gasol: false,
      eleUnit: 'kWh',
      waterUnit: 'm³',
      steamUnit: '吨',
      gasUnit: 'm³',
      dieselUnit: 't',
      gasolUnit: 'm³',

      totalData: '',
      ydlvalue: '',
      yslvalue: '',
      yzqlvalue: '',
      ytrqlvalue: '',
      dieselValue: '',
      gasolValue: '',
      ydlcost: '',
      yslcost: '',
      yzqlcost: '',
      ytrqlcost: '',
      dieselCost: '',
      gasolCost: '',
      tableshow: false,
      selectedDate: null,
      costData: [
        { name: '总费用', show: true },
        { name: '用电费用', show: true },
        { name: '用水费用', show: true },
        { name: '用蒸汽费用', show: true },
        { name: '用天然气费用', show: true },
        { name: '用柴油费用', show: true },
        { name: '用液化气体费用', show: true },
      ],
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    },
  },
  created () {
  },
  mounted () { },
  activated () { },
  methods: {
    resize () {
      this.myChart && this.myChart.resize()
      this.myChart_ && this.myChart_.resize()
    },
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return 'background-color: #F3F3F3;color: #666;'
      }
    },
    changeCompany (companyId) {
      this.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, '/cost/costOverview', null)
        .then((res) => {
          if (!res) return
          res.data.forEach((item) => {
            if (item.param == 'viewTree') {
              this.viewId = JSON.parse(item.value)[0].id
            } else if (item.param == 'type') {
              this.type = JSON.parse(item.value)
            } else if (item.param == 'unit') {
              this.matchUnit(JSON.parse(item.value))
            }
            const viewTreeData = findDataByParam('viewTree', true, res.data)
            this.viewTreeData = viewTreeData
            this.ydl = this.arrHasValue('用电量', this.type)
            this.ysl = this.arrHasValue('用水量', this.type)
            this.yzql = this.arrHasValue('用蒸汽量', this.type)
            this.ytrql = this.arrHasValue('用天然气量', this.type)
            this.diesel = this.arrHasValue('柴油', this.type)
            this.gasol = this.arrHasValue('用液化气体量', this.type)
            this.costData[1].show = this.ydl
            this.costData[2].show = this.ysl
            this.costData[3].show = this.yzql
            this.costData[4].show = this.ytrql
            this.costData[5].show = this.diesel
            this.costData[6].show = this.gasol
          })
        })
    },
    matchUnit (data) {
      let vm = this
      for (let i = 0; i < data.length; i++) {
        let item = data[i]
        if (item.type == 'ele') {
          vm.eleUnit = item.value
        }
        if (item.type == 'water') {
          vm.waterUnit = item.value
        }
        if (item.type == 'gas') {
          vm.gasUnit = item.value
        }
        if (item.type == 'diesel') {
          vm.dieselUnit = item.value
        }
        if (item.type == 'steam') {
          vm.steamUnit = item.value
        }
        if (item.type == 'gasol') {
          vm.gasolUnit = item.value
        }
      }
    },
    getObj (obj) {
      let dataAll = {}
      let data = []
      let lenged = []
      for (let i = 0; i < obj.length; i++) {
        for (let j in obj[i]) {
          lenged.push(j)
          data.push(obj[i][j] == '' ? '-' : obj[i][j])
        }
      }

      dataAll.data = data
      dataAll.lenged = lenged
      return dataAll
    },
    radioChange (e, index) {
      this.activecode = index
      let obj1 = {}
      switch (e) {
        case '总费用':
          obj1 = {
            dataone: this.getObj(this.AllData.costTrend.total).data,
            legend: ['总费用'],
            length: this.getObj(this.AllData.costTrend.total).lenged,
            title: '日平均负荷率曲线图',
          }
          this.getEchart(obj1)
          break
        case '用电费用':
          obj1 = {
            dataone: this.getObj(this.AllData.costTrend.electric).data,
            legend: ['用电费用'],
            length: this.getObj(this.AllData.costTrend.electric).lenged,
            title: '日平均负荷率曲线图',
          }
          this.getEchart(obj1)
          break
        case '用水费用':
          obj1 = {
            dataone: this.getObj(this.AllData.costTrend.water).data,
            legend: ['用水费用'],
            length: this.getObj(this.AllData.costTrend.water).lenged,
            title: '日平均负荷率曲线图',
          }
          this.getEchart(obj1)
          break
        case '用蒸汽费用':
          obj1 = {
            dataone: this.getObj(this.AllData.costTrend.steam).data,
            legend: ['用蒸汽费用'],
            length: this.getObj(this.AllData.costTrend.steam).lenged,
            title: '日平均负荷率曲线图',
          }
          this.getEchart(obj1)
          break
        case '用天然气费用':
          obj1 = {
            dataone: this.getObj(this.AllData.costTrend.gas).data,
            legend: ['用天然气费用'],
            length: this.getObj(this.AllData.costTrend.gas).lenged,
            title: '日平均负荷率曲线图',
          }
          this.getEchart(obj1)
          break
        case '用柴油费用':
          obj1 = {
            dataone: this.getObj(this.AllData.costTrend.diesel).data,
            legend: ['用柴油费用'],
            length: this.getObj(this.AllData.costTrend.diesel).lenged,
            title: '日平均负荷率曲线图',
          }
          this.getEchart(obj1)
          break
        case '用液化气体费用':
          obj1 = {
            dataone: this.getObj(this.AllData.costTrend.gasol).data,
            legend: ['用液化气体费用'],
            length: this.getObj(this.AllData.costTrend.gasol).lenged,
            title: '日平均负荷率曲线图',
          }
          this.getEchart(obj1)
          break
      }
    },
    timeControlChange () { },
    /* 查询 */
    bindgetSearchElem (e) {
      this.selectedDate = e
      if (this.selectedDate.dateType == 'day') {
        this.selectedDate.dataType = '1'
      } else if (this.selectedDate.dateType == 'month') {
        this.selectedDate.dataType = '2'
      } else if (this.selectedDate.dateType == 'year') {
        this.selectedDate.dataType = '3'
      } else if (this.selectedDate.dateType == 'years') {
        this.selectedDate.dataType = '4'
      }
      this.getData()
    },
    /* 树加载 */
    tabTreeDefault (e) {
      this.selectNodes = e
      let time = new Date()
      let startTime = dateTool.format(time, 'yyyy-MM-dd ') + '00:00:00'
      time.setDate(time.getDate() + 1)
      let endTime = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
      this.selectedDate = {
        dataType: '1',
        dateType: 'day',
        startTime: startTime,
        endTime: endTime,
      }
      this.bindgetSearchElem(this.selectedDate)
    },
    /* 树点击 */
    tabTreeClick (e) {
      this.selectNodes = e
      this.bindgetSearchElem(this.selectedDate)
    },
    getData () {
      let vm = this
      let startTime = vm.selectedDate.startTime
      console.log(vm.selectedDate.startTime)
      if (vm.selectedDate.dateType == 'years') {
        startTime = vm.selectedDate.startTime[0]
      }
      vm.$api.beadmin
        .getExpensesOfUse(
          vm.viewId,
          vm.selectedDate.dataType,
          startTime,
          vm.selectNodes.measureId
        )
        .then((res) => {
          this.AllData = res.data
          this.tabPosition = '总费用'
          if (this.AllData.childSituation.length == 0) {
            this.tableshow = false
          } else {
            this.tableshow = true
          }
          this.totalData = (
            this.AllData.totalCost.electricCost * 1 +
            this.AllData.totalCost.waterCost * 1 +
            this.AllData.totalCost.gasCost * 1 +
            this.AllData.totalCost.steamCost * 1 +
            this.AllData.totalCost.dieselCost * 1 +
            this.AllData.totalCost.gasolCost * 1
          ).toFixed(2)
          this.ydlvalue =
            this.AllData.totalCost.electricUsed == ''
              ? '-'
              : this.AllData.totalCost.electricUsed
          this.ydlcost =
            this.AllData.totalCost.electricCost == ''
              ? '-'
              : this.AllData.totalCost.electricCost
          this.yslvalue =
            this.AllData.totalCost.waterUsed == ''
              ? '-'
              : this.AllData.totalCost.waterUsed
          this.yslcost =
            this.AllData.totalCost.waterCost == ''
              ? '-'
              : this.AllData.totalCost.waterCost
          this.ytrqlvalue =
            this.AllData.totalCost.gasUsed == ''
              ? '-'
              : this.AllData.totalCost.gasUsed
          this.ytrqlcost =
            this.AllData.totalCost.gasCost == ''
              ? '-'
              : this.AllData.totalCost.gasCost
          this.yzqlvalue =
            this.AllData.totalCost.steamUsed == ''
              ? '-'
              : this.AllData.totalCost.steamUsed
          this.yzqlcost =
            this.AllData.totalCost.steamCost == ''
              ? '-'
              : this.AllData.totalCost.steamCost
          this.dieselValue =
            this.AllData.totalCost.dieselUsed == ''
              ? '-'
              : this.AllData.totalCost.dieselUsed
          this.dieselCost =
            this.AllData.totalCost.dieselCost == ''
              ? '-'
              : this.AllData.totalCost.dieselCost
          this.gasolValue =
            this.AllData.totalCost.gasolUsed == ''
              ? '-'
              : this.AllData.totalCost.gasolUsed
          this.gasolCost =
            this.AllData.totalCost.gasolCost == ''
              ? '-'
              : this.AllData.totalCost.gasolCost
          this.radioChange('总费用', 0)
          for (let i = 0; i < this.AllData.childSituation.length; i++) {
            let item = this.AllData.childSituation[i]
            for (const j in item) {
              if (item[j] === '') {
                item[j] = '-'
              }
            }
          }
          this.bottomTableData = this.AllData.childSituation
          let obj = []
          let name = []
          if (this.AllData.childSituation.length > 0) {
            for (let i = 0; i < this.AllData.proportion.length; i++) {
              obj.push({
                name: this.AllData.proportion[i].measureName,
                value: this.AllData.proportion[i].totalvalue,
              })
              name.push(this.AllData.proportion[i].measureName)
            }
            this.getPieEchart(obj, name)
          } else {
            obj = [
              this.ydl
                ? {
                  name: '用电费用',
                  value:
                    this.AllData.totalCost.electricCost == ''
                      ? '-'
                      : (this.AllData.totalCost.electricCost * 1).toFixed(2),
                  unit: this.eleUnit,
                }
                : null,
              this.ysl
                ? {
                  name: '用水费用',
                  value:
                    this.AllData.totalCost.waterCost == ''
                      ? '-'
                      : (this.AllData.totalCost.waterCost * 1).toFixed(2),
                  unit: this.waterUnit,
                }
                : null,
              this.ytrql
                ? {
                  name: '用天然气费用',
                  value:
                    this.AllData.totalCost.gasCost == ''
                      ? '-'
                      : (this.AllData.totalCost.gasCost * 1).toFixed(2),
                  unit: this.gasUnit,
                }
                : null,
              this.yzql
                ? {
                  name: '用蒸汽费用',
                  value:
                    this.AllData.totalCost.steamCost == ''
                      ? '-'
                      : (this.AllData.totalCost.steamCost * 1).toFixed(2),
                  unit: this.steamUnit,
                }
                : null,
              this.diesel
                ? {
                  name: '用柴油费用',
                  value:
                    this.AllData.totalCost.dieselCost == ''
                      ? '-'
                      : (this.AllData.totalCost.dieselCost * 1).toFixed(2),
                  unit: this.dieselUnit,
                }
                : null,
              this.gasol
                ? {
                  name: '用液化气体费用',
                  value:
                    this.AllData.totalCost.gasolCost == ''
                      ? '-'
                      : (this.AllData.totalCost.gasolCost * 1).toFixed(2),
                  unit: this.gasolUnit,
                }
                : null,
            ]
            name = [
              this.ydl ? '用电费用' : null,
              this.ysl ? '用水费用' : null,
              this.ytrql ? '用天然气费用' : null,
              this.yzql ? '用蒸汽费用' : null,
              this.diesel ? '用柴油费用' : null,
              this.gasol ? '用液化气体费用' : null,
            ]

            this.getPieEchart(obj, name)
          }
        })
    },
    getPieEchart (obj, name) {
      let this_ = this
      this.myChart = this.$echarts.init(document.getElementById('myChartPie'))
      if (this.myChart == null) {
        this.myChart = vm.$echarts.init(document.getElementById('myChartPie'))
      } else {
        this.myChart.clear()
      }
      this.myChart.resize()
      var option = {
        // title: {
        //   text: "同名数量统计",
        //   subtext: "纯属虚构",
        //   left: "center"
        // },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}元 ({d}%)',
        },
        legend: {
          //   type: "scroll",
          orient: 'vertical',
          right: 0,
          //   right: 10,
          // top: 0,
          // bottom: 20,
          data: name,
          // selected: data.selected
        },
        series: [
          {
            type: 'pie',
            radius: '55%',
            center: ['40%', '55%'],
            data: obj,
            avoidLabelOverlap: true,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            label: {
              //   position: "outside",
              //   alignTo: "edge",
              //   margin: "50%",
              // formatter: "{b}\n{c}kWh\n({d}%)",
              formatter: function (params) {
                let pieName = params.name.split('/').join(' ')
                let num = params.value
                let percent = params.percent

                return pieName + '\n' + num + '元' + '\n' + percent + '%'
              },
              color: '#000',
              fontWeight: 'bolder',
            },
          },
        ],
      }
      this.myChart.setOption(option, true)
      if (this.myChart) {
        window.addEventListener('resize', function () {
          this_.myChart.resize()
        })
      }
    },
    getEchart (obj) {
      let this_ = this
      this.myChart_ = this.$echarts.init(document.getElementById('lineCharts'))
      if (this.myChart_ == null) {
        this.myChart_ = vm.$echarts.init(document.getElementById('lineCharts'))
      } else {
        this.myChart_.clear()
      }
      this.myChart_.resize()
      var option = {
        // title: {
        //   text: obj.title,
        //   left: "center"
        // },
        grid: {
          x: 80,
          y: 50,
          x2: 50,
          y2: 60,
          width: '92%',
          borderWidth: 10,
        },

        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: obj.legend,
          top: '6%',
          // icon: "line"
        },

        dataZoom: [
          {
            type: 'inside',
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: 'slider',
            width: '92%',
            left: 'center',
          },
        ],
        toolbox: {
          top: '5%',
          right: '2%',
          show: true,
          feature: {
            // dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            // restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: obj.length,
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '元',
          },
        ],
        series: [
          {
            name: obj.legend,
            data: obj.dataone,
            type: 'bar',
            smooth: true,
            // markLine: {
            //   // symbol: "none", //去掉警戒线最后面的箭头
            //   label: {
            //     formatter: "{c}" + "%",
            //     position: "end" //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
            //   },
            //   data: [
            //     {
            //       silent: false, //鼠标悬停事件  true没有，false有
            //       lineStyle: {
            //         //警戒线的样式  ，虚实  颜色
            //         type: "solid",
            //         color: "#FA3934"
            //       },
            //       yAxis: this.warnValue // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            //     }
            //   ]
            // }
          },
        ],
      }
      this.myChart_.setOption(option, true)
      if (this.myChart_) {
        window.addEventListener('resize', function () {
          this_.myChart_.resize()
        })
      }
    },
    //判断有没有这个值
    arrHasValue (v, arr) {
      var output = false
      for (var i in arr) {
        if (v == arr[i]) {
          output = true
          return output
        }
      }
      output = false
      return output
    },
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
  },
}
</script>
<style lang="scss" scoped>
.toptitle {
  font-size: 1rem;
  padding: 0.4rem 0.6rem;
  color: #fff;
}
.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  height: 100%;
  width: 100%;
  margin-right: 14px;
}
.right-content {
  height: 100%;
  position: relative;
  overflow: auto;
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 100%;
}
.topleftcontent {
  display: flex;
  // margin-left: 50px;
  justify-content: space-around;
  height: 75%;
}
.littlecontent {
  margin-left: 10px;
  width: 100%;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  border: 1px solid #5ba7e8;
}
.littlecontent:last-child {
  margin-right: 10px;
  width: 100%;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  border: 1px solid #5ba7e8;
}
.toplittle {
  display: flex;
  width: 100%;
  background: #5ba7e8;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 50%;
  div:first-child {
    font-size: 1.4rem;
    span {
      font-size: 0.3rem;
    }
  }
  div:last-child {
    font-size: 2rem;
  }
}
.bottomlittle {
  display: flex;
  width: 100%;
  background: #f9f9f9;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 50%;
  color: #5ba7e8;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  div:first-child {
    font-size: 1.4rem;
    span {
      font-size: 0.3rem;
    }
  }
  div:last-child {
    font-size: 2rem;
  }
}
.show-ellipsis {
  display: block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 0;
  //   border-left: 1px solid #00388c;
}
::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0;
  //   border-right: 1px solid #00388c;
}
::v-deep .el-radio-button:first-child:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button__inner {
  background: #3f9efe;
  color: #fff;
  // border: 0;
  //   border-top: 1px solid #00388c;
  //   border-bottom: 1px solid #00388c;
  // border-right: 1px solid #00388c;
  // border-left: 1px solid #fff;
}
.box1 {
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow: hidden;
  box-sizing: border-box;
}
.boxNew {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}
.el-row {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.el-col {
  border-radius: 4px;
  height: 100%;
}
.grid-content {
  width: 100%;
  height: 100%;
  display: flex;
}
.parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.tree_parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.treecontent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
  border-radius: 5px;
}

.bgbox {
  padding-top: 0;
  box-sizing: border-box;
  padding: 0;
  // height: 789;
  display: flex;
  flex-flow: column;
  flex: 1;
}
.time_box {
  width: 100%;
  margin-bottom: 14px;
  color: #000;
}
// .contant_box {
//     background: #fff;
//     padding: 14px;
//     box-sizing: border-box;
//     border: 1px solid #eee;
//     border-radius: 5px;
//     display: flex;
//     flex: 1;
//     flex-flow: column;
// }
.box_btn {
  height: 40px;
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: flex-end;
  border-bottom: 2px solid #00368e;
}
.box_btn p {
  font-size: 14px;
  color: #000;
  height: 30px;
  width: 96px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #f5f5f5;
  border-bottom: none;
  cursor: pointer;
}
.box_btn .active {
  background: #00368e;
  color: #fff;
}
.box_con {
  position: absolute;
  top: 50px;
  bottom: 0px;
  width: 100%;
  display: flex;
}
.box_con_ {
  position: absolute;
  top: 45px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
}
.chart_box {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.table_box {
  position: absolute;
  top: 615px;
  width: 100%;
  height: auto;
}
.charts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.elechart_box {
  width: 100%;
  height: auto;
}
.eletable_box {
  width: 100%;
  height: auto;
}

// 内容展示部分
.contant_box {
  padding: 14px;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 5px;
  display: flex;
  flex: 1;
  flex-flow: column;
  overflow: auto;
  > .top {
    display: flex;
    justify-content: space-between;
    margin-top: 0.4rem;
    text-align: left;
    > .block {
      > .title {
        font-size: 1rem;
        padding: 0.4rem 0.6rem;
        color: #fff;
        // background: #00388c;
      }
      flex: 1;
      max-height: 20rem;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      overflow: hidden;
      border: 1px solid #ccc;
    }
    > .block:first-child {
      > .content {
        display: flex;
        justify-content: space-between;
        > .left {
          width: 54%;
          padding: 3rem 0.4rem;
          border-right: 1px solid #ccc;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          > div {
            text-align: center;
          }
          > div:first-child {
            height: 70%;
          }
        }
        > .right {
          flex: 1;
          padding: 0.4rem;
          position: relative;
          > .title {
            font-weight: bold;
          }
          > .content {
            color: #666;
            p {
              width: 100%;
              padding: 0.3rem 0;
              border-bottom: 1px solid #ccc;
            }
            p:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
    > .block:nth-child(2) {
      margin: 0 0 0 0.3rem;
      > .content {
        .total {
          display: flex;
          justify-content: space-around;
          line-height: 2rem;
          padding-top: 1rem;
          p:first-child {
            color: #999;
            font-size: 1.2rem;
          }
          p:last-child {
            font-size: 1.8rem;
            color: #00388c;
          }
        }
        .wrapper {
          display: flex;
          justify-content: space-between;
          .ablock {
            flex: 1;
            margin: 1rem;
            .num {
              background: #37cac0;
              color: #fff;
              text-align: center;
              padding: 0.8rem 0.4rem;
              border-radius: 0.4rem;
            }
            .money {
              text-align: center;
              padding: 0.8rem 0.4rem;
              border-radius: 0.4rem;
              background: #eee;
              p:first-child {
                color: #37cac0;
                margin-bottom: 1.4rem;
              }
            }
          }
        }
      }
    }
    > .block:last-child {
      #pieEcharts {
        width: 100%;
        height: 100%;
      }
    }
  }
  > .center {
    margin-top: 0.4rem;
    > .title {
      font-size: 1rem;
      padding: 0.4rem 0.6rem;
      color: #fff;
    }
    > .content {
      width: 100%;
      height: 20rem;
      #lineCharts {
        height: 100%;
      }
    }
  }
  > .bottom {
    margin-top: 0.4rem;
    > .title {
      font-size: 1rem;
      padding: 0.4rem 0.6rem;
      color: #fff;
      text-align: left;
    }
  }
}
.position {
  position: relative;
}
.margintop {
  margin-top: 10px;
}
.new-con {
  // position: absolute;
  // top: 40px;
  // bottom: 0;
  width: 100%;
  // width: 32.5%;
  padding: 10px;
  box-sizing: border-box;
  .top_title {
    height: 25px;
    line-height: 25px;
  }
  .left-con {
    position: absolute;
    top: 60px;
    bottom: 0;
    left: 10px;
    right: 10px;
    .ptitle {
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      font-weight: bold;
    }
    .con_left {
      position: absolute;
      top: 30px;
      bottom: 0;
      left: 10px;
      right: 10px;
      overflow: auto;
      p {
        height: 30px;
        line-height: 30px;
        border-bottom: 1px solid #ccc;
      }
    }
  }
}
.btn {
  display: inline-block;
  height: 1.8rem;
  line-height: 1.9rem;
  border: none;
  padding: 0 0.9rem;
  white-space: nowrap;
  text-align: center;
  font-size: 0.7rem;
  cursor: pointer;
  outline: none;
  font-weight: bold;
  height: 33px;
  color: #fff;
}
.btnactive {
  color: #0197ee !important;
}
</style>
